import { PublicClientApplication } from "@azure/msal-browser";
import { buildConsoleMsalConfig, CONSOLE_LOGIN_SCOPES } from "./msalConfig";

/**
 * One MSAL instance for the console SPA, built lazily so the module can be imported
 * before console runtime config has loaded (tests, and index.tsx's own import graph).
 * More than one PublicClientApplication causes cache and account mismatches, which is
 * why the product SPA keeps a single instance too.
 */
let _instance: PublicClientApplication | null = null;

export function getConsoleMsalInstance(): PublicClientApplication {
  if (!_instance) {
    _instance = new PublicClientApplication(buildConsoleMsalConfig());
  }
  return _instance;
}

/** Test seam: inject a double, or clear the cached instance between suites. */
export function __setConsoleMsalInstanceForTests(
  instance: PublicClientApplication | null,
): void {
  _instance = instance;
}

export { CONSOLE_LOGIN_SCOPES };
